module.exports = __webpack_public_path__ + "static/media/Carousel1.ced61aac.png";